export interface SmartCaptcha {
  render: (
    container: HTMLElement,
    params: {
      sitekey: string;
      hl?: string;
      callback?: (token: string) => void;
    },
  ) => number;
  subscribe: (
    widgetId: number,
    event: 'token-expired',
    handler: () => void,
  ) => void;
  reset: (widgetId: number) => void;
  destroy: (widgetId: number) => void;
}

declare global {
  interface Window {
    smartCaptcha?: SmartCaptcha;
  }
}

const SCRIPT_URL = 'https://smartcaptcha.cloud.yandex.ru/captcha.js';

/** Module-level, so every opening of the modal shares one script per page */
let scriptPromise: Promise<SmartCaptcha> | null = null;

export const loadSmartCaptcha = (): Promise<SmartCaptcha> => {
  if (window.smartCaptcha) return Promise.resolve(window.smartCaptcha);

  scriptPromise ??= new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () =>
      window.smartCaptcha ? resolve(window.smartCaptcha) : reject();
    // Dropped so the next opening of the form tries again
    script.onerror = () => {
      scriptPromise = null;
      script.remove();
      reject();
    };
    document.head.append(script);
  });

  return scriptPromise;
};
